// Compact, categorized emoji picker — no external library.
// ~250 most-used emojis split into 7 categories.

export const EMOJI_CATEGORIES = [
  { id: 'smileys', label: '😀', name: 'Smileys', emojis: [
    '😀','😃','😄','😁','😆','😅','🤣','😂','🙂','🙃','😉','😊','😇','🥰','😍','🤩',
    '😘','😗','😚','😙','😋','😛','😜','🤪','😝','🤑','🤗','🤭','🤫','🤔','🤐','🤨',
    '😐','😑','😶','😏','😒','🙄','😬','🤥','😌','😔','😪','🤤','😴','😷','🤒','🤕',
    '🤢','🤮','🥵','🥶','🥴','😵','🤯','🤠','🥳','😎','🤓','🧐','😕','😟','🙁','☹️',
    '😮','😯','😲','😳','🥺','😦','😧','😨','😰','😥','😢','😭','😱','😖','😣','😞',
    '😓','😩','😫','🥱','😤','😡','😠','🤬','😈','👿','💀','☠️','💩','🤡','👻','👽',
  ]},
  { id: 'gestures', label: '👍', name: 'Gestures', emojis: [
    '👋','🤚','🖐️','✋','🖖','👌','🤌','🤏','✌️','🤞','🤟','🤘','🤙','👈','👉','👆',
    '🖕','👇','☝️','👍','👎','✊','👊','🤛','🤜','👏','🙌','👐','🤲','🤝','🙏','✍️',
    '💅','🤳','💪','🦾','🦵','🦶','👂','🦻','👃','🧠','🫀','🫁','🦷','🦴','👀','👁️',
  ]},
  { id: 'hearts', label: '❤️', name: 'Hearts', emojis: [
    '❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖',
    '💘','💝','💟','♥️','💌','💋','💍','💎','🌹','🌺',
  ]},
  { id: 'objects', label: '💼', name: 'Objects', emojis: [
    '💼','💻','🖥️','⌨️','🖱️','💾','📱','☎️','📞','📟','📠','📷','📹','🎥','📺','📻',
    '🎙️','⏰','⏱️','⌚','📡','🔋','🔌','💡','🔦','💵','💴','💶','💷','💰','💳','💸',
    '📈','📉','📊','💹','🏦','🪙','💱','💲','🧾','📝','📃','📄','📊','📋','📌','📍',
    '✏️','✒️','🖋️','🖊️','🖍️','📝','💌','📦','📫','📮','📪','🗳️','🔑','🔐','🔒','🔓',
  ]},
  { id: 'symbols', label: '✅', name: 'Symbols', emojis: [
    '✅','✔️','☑️','✖️','❌','❎','➕','➖','➗','♾️','‼️','⁉️','❓','❔','❗','❕',
    '〽️','⚠️','🚸','🔱','📛','🔰','♻️','⚜️','🔱','📵','🚫','🔞','✳️','❇️','⭐','🌟',
    '💫','✨','⚡','🔥','💥','💢','💯','🆙','🆒','🆓','🆕','🆖','🆗','🆙','🆚','🅰️',
    '🅱️','🆎','🅾️','🆑','💠','🔘','🟥','🟧','🟨','🟩','🟦','🟪','🟫','⚫','⚪',
  ]},
  { id: 'finance', label: '📊', name: 'Trading', emojis: [
    '📈','📉','📊','💹','💰','💵','💴','💶','💷','💸','💳','🪙','💱','💲','🏦','💎',
    '⚖️','🎯','🚀','🌙','🐂','🐻','🦅','🦁','🛡️','⚔️','🏆','🥇','🥈','🥉','🎖️','🏅',
    '⚡','🔥','💧','💯','📌','🔔','🔕','⏳','⌛','🕐','📅','📆','🗓️','📇','🗃️','🗂️',
  ]},
  { id: 'nature', label: '🌍', name: 'Travel', emojis: [
    '🌍','🌎','🌏','🌐','🗺️','🧭','🏔️','⛰️','🌋','🗻','🏕️','🏖️','🏜️','🏝️','🏞️','🏟️',
    '🏛️','🏗️','🧱','🪨','🪵','🛖','🏘️','🏚️','🏠','🏡','🏢','🏣','🏤','🏥','🏦','🏨',
    '🏩','🏪','🏫','🏬','🏭','🏯','🏰','💒','🗼','🗽','✈️','🛩️','🚀','🛸','🚁','🚆',
  ]},
];

export default EMOJI_CATEGORIES;
